import React from "react";
import { ResponseTab } from "./ResponstTab";
import { useSelector } from "react-redux";

export const RFITemplateBuilder = () => {
  const { client_id, client_secret } = useSelector(
    (state) => state.clientSecrets
  );
  return (
    <div className="w-full ">
      {client_id && client_secret && (
        <ResponseTab
          clientSecrets={{ client_id, client_secret }}
          route={"/due-diligence/templates?hideNavigation=true"}
          heading={"View Templates"}
          desc={"templates"}
        />
      )}
    </div>
  );
};
